<template>
  <div class="dialog_header_holder">
    <v-row justify="space-between" align="center">
      <v-col v-if="(showBackArrow || showClose || $slots.leftIcon) && !titleLeft" cols="auto">
        <div :class="{ button_holder: !$slots.leftIcon }">
          <v-btn
            v-if="showBackArrow || leftIcon"
            ref="click-back"
            fab
            width="48"
            height="48"
            @click="clickBack"
          >
            <v-img
              v-if="!leftIcon"
              contain
              width="24"
              height="24"
              :src="$asset('img/icons/arrow.svg')"
            />
            <v-img v-else-if="leftIcon.includes('/')" :src="$asset(`img/${leftIcon}`)"></v-img>
            <v-icon v-else-if="leftIcon">{{ leftIcon }}</v-icon>
          </v-btn>
          <slot name="leftIcon"></slot>
        </div>
      </v-col>
      <v-col>
        <div class="text-h2" :class="{ 'text-center': !titleLeft }">
          <slot></slot>
        </div>
      </v-col>
      <v-col v-if="showBackArrow || showClose" cols="auto">
        <div class="button_holder" data-cy="dialogHeaderButtonHolder">
          <CloseButton v-if="showClose" @click="$emit('close')" />
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'DialogHeader',
  props: {
    showBackArrow: {
      type: Boolean,
      default: true
    },
    leftIcon: {
      type: String,
      default: null
    },
    showClose: {
      type: Boolean,
      default: false
    },
    titleLeft: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    clickBack() {
      this.$refs[`click-back`].$el.blur();
      this.$emit('clickBack');
    }
  }
};
</script>

<style lang="scss" scoped>
.dialog_header_holder {
  width: 100%;

  .button_holder {
    width: 48px;
  }
}
</style>
